// extracted by css-extract-rspack-plugin
export default {"transition":"jrlxQe"};